import { Component, Vue, Prop } from 'vue-property-decorator';
import { AxiosError } from 'axios';
import ErrorHandler from '@/support/ErrorHandler';
import { EnglishRules, Rules, validationRules } from '@/support/ValidationRules';
import { Season } from '@/models/Season';

@Component<CreateDialog>({})
export default class CreateDialog extends Vue {
  @Prop({default: null})
  protected season!: Season;

  protected newSeason: Season = new Season();
  protected isLoading: boolean = true;
  protected valid: boolean = false;
  protected rules: Rules = EnglishRules;

  mounted() {
    if(this.season) {
      this.newSeason = this.season.clone();
    }
  }

  private getTranslation(key: string) {
    return this.$t(key);
  }


  protected close() {
    this.$emit('input', false);
    this.clear();
  }

  protected createOrUpdate() {
    if(this.newSeason.id) {
      this.update();
    } else {
      this.create();
    }
  }

  protected async update() {
    this.isLoading = true;
    if(!this.newSeason) {
      return;
    }

    await this.newSeason
      .update()
      .then((season: Season) => {
        this.isLoading = false;
        this.$emit("seasonUpdated");
        this.close();
      })
      .catch((error: AxiosError) => {
        ErrorHandler.network(error);
      });
  }

  protected async create() {
    if (!this.canSaveSeason) {
      return;
    }

    this.isLoading = true;
    await this.newSeason
    .create()
    .then((season: Season) => {
      this.isLoading = false;
      this.$emit("seasonCreated");
      this.close();
    })
    .catch((error: AxiosError) => {
      ErrorHandler.network(error);
    });
  }

  protected get canSaveSeason() {
    if(this.newSeason && this.newSeason.name && this.newSeason.name.length > 0) {
      return true;
    }

    return false;
  }

  protected get saveButtonText() {
    if(this.newSeason && this.newSeason.id) {
      return 'Edit';
    }

    return 'Add';
  }

  protected clear() {
    this.newSeason = new Season();
  }
}
